// LiBRARY
import React from 'react';
import Questiontable from './table'


class Questionnaire extends React.Component {
  render() {
    return ( 
      <div style={{marginTop: -50}}>
        <Questiontable />
      </div>
    );
  }
}

export default Questionnaire;